import { Injectable } from '@angular/core';
import { MethodsService } from './methods.service';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class InteractionsService {

  public interactions$ = new BehaviorSubject<any>(null);
  public interactions;

  public interactionsOpened = localStorage.getItem('interactionIds');
  public interactionsCompleted = localStorage.getItem('interacionsCompletedIds');
  public interactionsOpenedArray = [];
  public interactionsCompletedArray = [];

  constructor(
    private methods: MethodsService
  ) { }

  public getInteractions() {
    const language = localStorage.getItem('l');
    this.methods.get('./assets/data/'+ language +'/interactions.json').pipe(
      map(data => {
        return data.map(interaction => {
          return {
            id: interaction.id,
            title: interaction.title,
            instructions: interaction.instructions,
            thumbnail: interaction.thumbnail,
            url: interaction.url,
            comingSoon: interaction.comingSoon,
            opened: 0,
            completed: {
              onComplete: false,
              status: null
            },
            messages: interaction.onComplete.messages,
            type: interaction.type,
            orientation: interaction.orientation,
            content: interaction.content,
            onComplete: interaction.onComplete
          };
        });
      })
    )
    .subscribe(interactions => {
      this.interactions = this.updateInteractionsWithLocalData(interactions);
      this.interactions$.next(this.interactions);
    });
  }

  updateInteractionsWithLocalData(interactions) {
    return interactions.map(interaction => {
      if (this.interactionsOpened) {
        this.interactionsOpenedArray = JSON.parse(this.interactionsOpened);
        if (_.indexOf(this.interactionsOpenedArray, interaction.id) > -1) {
          interaction.opened = 1;
        }
      }
      if (this.interactionsCompleted) {
        this.interactionsCompletedArray = JSON.parse(this.interactionsCompleted);
        if (this.interactionsCompletedArray.find(int => int.id === interaction.id)) {
          interaction.completed = {
            onComplete: true,
            status: this.interactionsCompletedArray.find(int => int.id === interaction.id).status
          };
        }
      }
      return interaction;
    });
  }

  updateInteraction(interaction) {
    this.interactions.filter(int => {
      if (int.id === interaction.id) {
        int = interaction;
      }
    });
    this.interactions$.next(this.interactions);
  }

  setCompleted(interaction) {

    let totalpoints;
    if(localStorage.getItem('points')){

      if (this.interactionsCompletedArray.filter(int => int.id === interaction.id).length <= 0) {
        console.log('interazione non presente')
        const pointsEarned = localStorage.getItem('points')
        const newPoints = +pointsEarned + 10
        localStorage.setItem('points', newPoints.toString())

      }else{
        console.log('interazione presente')
      }

    }else{
      localStorage.setItem('points', '10')
    }

    if (this.interactionsCompletedArray.filter(int => int.id === interaction.id).length <= 0) {
      this.interactionsCompletedArray.push( {id: interaction.id, status: interaction.completed.status} );
      localStorage.setItem('interacionsCompletedIds', JSON.stringify(this.interactionsCompletedArray));
    }

  }

  resetInteraction(interaction) {
    interaction.completed = {
      onComplete: false,
      status: null
    };
/*    this.interactionsCompletedArray = JSON.parse(localStorage.getItem('interacionsCompletedIds'));
    this.interactionsCompletedArray = this.interactionsCompletedArray.filter(int => int.id !== interaction.id);
    localStorage.setItem('interacionsCompletedIds', JSON.stringify(this.interactionsCompletedArray));*/
    this.updateInteraction(interaction);
  }
}
